angular
  .module('contabilidad.buscarimportes')
  .service('ContabilidasBuscarImportes', ContabilidasBuscarImportes)

ContabilidasBuscarImportes.$inject = ['$http']

function ContabilidasBuscarImportes ($http) {
  this.getEmpresas = getEmpresas
  this.getListado = getListado

  // this.asignarFacturas = asignarFacturas;

  function getEmpresas () {
    return $http.get('/kendu/contabilidad/asociarfacturas/empresas')
  }

  function getListado (busqueda) {
    return $http.get('/api/empresa/cuentabancaria/movimientos', {
      params: {
        empresa: busqueda.empresa,
        cuentabancaria: busqueda.cuentabancaria,
        fechaInicial: busqueda.fechaInicial.toYMD(),
        fechaFinal: busqueda.fechaFinal.toYMD(),
        importe: busqueda.importe,
      },
      schema: schema,
    })
  }

  /*function asignarFacturas(busqueda, data){
    return $http.post('/kendu/contabilidad/asociarfacturas/asignarfacturas', {data : data},{
      params :{
          empresa : busqueda.empresa,
          cuentabancaria : busqueda.cuentabancaria,
          fechaInicial : busqueda.fechaInicial.toYMD(),
          fechaFinal : busqueda.fechaFinal.toYMD(),
          naturaleza : busqueda.naturaleza
      },
      schema : schema
    });
}*/

  var schema = {
    Fecha_Movimiento: 'date',
    importe: 'number',
    pagado_fecha: 'datetime',
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/buscarimportes/services/ContabilidadBuscarImportes.js